import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { reservationApi } from '../services/api'

export default function Cancel() {
  const { token } = useParams<{ token: string }>()
  const [status, setStatus] = useState<'confirm' | 'loading' | 'done' | 'error'>('confirm')
  const [errorMessage, setErrorMessage] = useState('')

  const handleCancel = async () => {
    setStatus('loading')
    try {
      await reservationApi.cancelByToken(token!)
      setStatus('done')
    } catch (err: any) {
      setErrorMessage(err.response?.data?.error || 'キャンセルに失敗しました')
      setStatus('error')
    }
  }

  if (status === 'done') {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.title}>キャンセル完了</h1>
          <p style={styles.success}>予約をキャンセルしました。</p>
          <a href="/" style={styles.button}>新しい予約をする</a>
        </div>
      </div>
    )
  }

  if (status === 'error') {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.title}>エラー</h1>
          <p style={styles.error}>{errorMessage}</p>
          <a href="/" style={styles.button}>トップページへ</a>
        </div>
      </div>
    )
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>予約キャンセル</h1>
        <p style={styles.message}>この予約をキャンセルしてもよろしいですか？</p>
        <p style={styles.note}>※キャンセル後は元に戻せません</p>
        <div style={styles.buttons}>
          <button
            onClick={handleCancel}
            style={styles.cancelButton}
            disabled={status === 'loading'}
          >
            {status === 'loading' ? 'キャンセル中...' : 'キャンセルする'}
          </button>
          <a href="/" style={styles.backButton}>戻る</a>
        </div>
      </div>
    </div>
  )
}

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    padding: '20px'
  },
  card: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '400px',
    textAlign: 'center'
  },
  title: { color: '#333', marginBottom: '24px' },
  message: { fontSize: '16px', color: '#333', marginBottom: '8px' },
  note: { fontSize: '13px', color: '#e74c3c', marginBottom: '24px' },
  buttons: { display: 'flex', flexDirection: 'column', gap: '12px' },
  cancelButton: {
    padding: '12px',
    backgroundColor: '#e74c3c',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer'
  },
  backButton: {
    padding: '12px',
    backgroundColor: '#95a5a6',
    color: 'white',
    borderRadius: '4px',
    fontSize: '16px',
    textDecoration: 'none'
  },
  success: { color: 'green', fontSize: '16px', marginBottom: '24px' },
  error: { color: 'red', fontSize: '16px', marginBottom: '24px' },
  button: {
    display: 'block',
    padding: '12px',
    backgroundColor: '#1F4E79',
    color: 'white',
    borderRadius: '4px',
    fontSize: '16px',
    textDecoration: 'none'
  }
}
